module.exports = __webpack_public_path__ + "static/media/ic-transparent-price.cf3a7a6f.svg";